import {observer} from "mobx-react";
import * as React from "react";
import {useTheme} from "@mui/material";
import ListCurrentAccountsFeature from "./ListCurrentAccountsFeature";
import {useNavigate} from "react-router-dom";
import {useApplication} from "../../../ApplicationProvider";
import {useNavigatorFeature} from "../../../useFeature";
import LayoutContentWrapper from "../../../components/layout/LayoutContentWrapper";
import LayoutContentToolbar from "../../../components/layout/LayoutContentToolbar";
import Table from "../../../components/table/Table";
import PortfolioAgingScreen from "./portfolio_aging/PortfolioAgingScreen";
import portfolioCellRenderers from "./PortfolioCellRenderers";
import CurrentAccountsTableSkeleton from "./CurrentAccountsTableSkeleton";
import KamDailyReportPreviewModal from "./KamDailyReportPreviewModal";
import FilledButton from "../../../components/buttons/FilledButton";
import PaymentReminderIconButton from "../payment_reminder/PaymentReminderIconButton";
import PaymentReminderModal from "../payment_reminder/PaymentReminderModal";

function ListCurrentAccountsScreen() {
    const application = useApplication();
    const navigator = useNavigate();
    const theme = useTheme();
    const feature = useNavigatorFeature(() => new ListCurrentAccountsFeature(application, navigator), navigator);

    const isFeatureReady = (feature) => {
        return feature && feature.loaded
    }

    const columnsRenderer = {
        ...portfolioCellRenderers(theme),
        paymentReminder: (params) => (
            <PaymentReminderIconButton
                hasOverdueInvoices={params.row.hasOverdueInvoices}
                onClick={() => feature.openPaymentReminderFor(params.row)}/>
        ),
    };

    const listCurrentAccountsContentWith = (currentAccountsSection) => {
        return (
            <div>
                <LayoutContentToolbar title="Cuentas Corrientes">
                    {isFeatureReady(feature) && feature.canSendKamDailyReports() &&
                        <FilledButton onClick={() => feature.openKamDailyReportPreview()}>
                            Envío KAM
                        </FilledButton>}
                </LayoutContentToolbar>

                <PortfolioAgingScreen/>

                {currentAccountsSection}

                {isFeatureReady(feature) &&
                    <KamDailyReportPreviewModal feature={feature.kamDailyReportPreviewFeature}/>}
                {isFeatureReady(feature) &&
                    <PaymentReminderModal feature={feature.paymentReminderFeature}/>}
            </div>
        )
    }

    const currentAccountsTable = () => {
        return (
            <Table columns={feature.columnsContent()} rows={feature.presentedCurrentAccounts()}
                   columnsRenderer={columnsRenderer}
                   defaultSortModel={feature.defaultSortModel()}
                   selectFilters={feature.selectFilters()}
                   quickFilters={feature.quickFilters()}
                   navigateToRowObjectScreen={(params) => feature.navigateToCurrentAccountScreen(params.row)}/>
        )
    }

    return (
        <LayoutContentWrapper isLoading={!isFeatureReady(feature)}
                              skeleton={listCurrentAccountsContentWith(<CurrentAccountsTableSkeleton/>)}
                              renderContent={() => listCurrentAccountsContentWith(currentAccountsTable())}/>
    )
}

export default observer(ListCurrentAccountsScreen)
